// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { getMetricCopy, getPageCopy } from "..";
import { ViewMethodology } from "../types";

/**
 * All methodology attribute blocks are in Markdown
 */
export const usMoMethodology: ViewMethodology = {
  system: {
    title: "Pathways",
    description: `Pathways provides a real-time map of the corrections system and helps identify patterns of success and failure among specific cohorts of people.`,
    get pageCopy() {
      return getPageCopy("US_MO");
    },
    get metricCopy() {
      return getMetricCopy("US_MO");
    },
  },
};
